import React from "react";
import TopHeaderNotifications from "./TopHeaderNotifications";
import FormSearch from "./FormSearch";
import { useHistory, useLocation } from "react-router-dom";
import { clearAllCookies } from "../../../utils";
import CardUpgrade from "../Plans/CardUpgrade";
import BuyAdditionalNotes from "../Plans/BuyAdditionalNotes";
import NotesQuantityIcon from "../Plans/NotesQuantityIcon";
import ModalGetAccounting from "../Branches/Accounting/PopUpModal";
import { getBranchPlan } from "../../../api/plans";
import styled from "styled-components";

import Button from "../../../_components/Button";
import IconButton from "../../../_components/IconButton";
import ButtonNews from "./ButtonNews";
import Nav from "./Nav";

import AppContext from "../context";


const HeaderButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;

  * {
  margin-left: 10px;
  margin-right: 10px;
}
  @media (max-width: 700px) {
    font-size: 0.9em;
    * {
      margin-left: 3px;
      margin-right: 3px;
    } 
  }
`;

const NavRight = styled.div`
  display: flex;
  align-items: baseline;
`;
const NavLeft = styled.div`
  display: flex;
  align-items: baseline;
  @media (max-width: 700px) {
    ul {
      display: flex;
      justify-content: end;
    }
  }
`;





export default (props) => {
  const [showAdditionalNotes, setShowAdditionalNotes] = React.useState(false);
  const history = useHistory();
  const [width, setWidth] = React.useState(window.innerWidth);
  const [keysPressed, setKeysPressed] = React.useState([])
  const navRef = React.useRef(null);
  const context = React.useContext(AppContext);
  const [branchPlan, setBranchPlan] = React.useState({})

  const location = useLocation();
  const isNfeIssuer = location.pathname === "/nfe/issuer";


  function init() {
    getBranchPlan()
      .then((plan) => {
        plan.total_notes = plan.notes_quantity
        plan.available_notes = 0
        if (plan.total_sended_notes > plan.notes_quantity) {

          if (plan.additional_notes) {
            plan.available_notes = plan.additional_notes.quantity
          } else {
            plan.available_notes = 0;
          }

        } else {
          plan.available_notes = plan.total_notes - plan.total_sended_notes;
        }
        setBranchPlan(plan)

      })
      .catch((error) => {
        if (error.data) {
          if (error.data.error) {
          }
        }
      })
      .finally();
  }

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  function logOut() {
    const hideBanner = localStorage.getItem("easygestor_hide_startup_awards_banner_2026");
    clearAllCookies();
    localStorage.clear();
    if (hideBanner) {
      localStorage.setItem("easygestor_hide_startup_awards_banner_2026", hideBanner);
    }
    window.location.reload(true);
  }

  function conditionToShowButtonAdditionalNotes() {
    if (["/", "/settings"].includes(window.location.pathname)) {
      if (context.currentBranch && context.currentBranch.branch_plan) {
        setShowAdditionalNotes(
          context.currentBranch.branch_plan.plan !==
          "b85046a1-3803-4ee4-a858-8ef2c26d9d76"
        );
      }
    } else {
      setShowAdditionalNotes(false);
    }
  }
  function toggleNavBar() {
    if (document.querySelector(".mini-navbar")) {
      document.querySelector("body").classList.remove("mini-navbar");
    } else {
      document.querySelector("body").classList.add("mini-navbar");
    }
  }

  React.useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);


  React.useEffect(() => {
    const handleKeyDown = (event) => {
      setKeysPressed((prevKeys) => {
        const maxSequenceLength = 9;
        const newKeys = [...prevKeys, event.key]
        return newKeys.slice(-maxSequenceLength)
      });
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  React.useEffect(() => {
    const sequenceBranch = ['ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowDown', 'ArrowDown'];
    const sequenceCristiano = ['c', 'r', 'i', 's', 't', 'i', 'a', 'n', 'o'];

    if (keysPressed.length >= sequenceBranch.length) {
      const recentBranch = keysPressed.slice(-sequenceBranch.length);
      if (recentBranch.every((key, index) => key === sequenceBranch[index])) {
        if (context["currentBranch"]) {
          navigator.clipboard.writeText(context["currentBranch"].id)
          setKeysPressed([]);
        }
      }
    }

    if (keysPressed.length >= sequenceCristiano.length) {
      const recentCristiano = keysPressed.slice(-sequenceCristiano.length).map(k => typeof k === 'string' ? k.toLowerCase() : k);
      if (recentCristiano.every((key, index) => key === sequenceCristiano[index])) {
        localStorage.setItem("arcadeIntegration", "true");
        window.dispatchEvent(new Event("arcadeEvent"));
        setKeysPressed([]);
      }
    }
  }, [keysPressed, context["currentBranch"]])

  React.useEffect(init, [])

  return (
    <Nav className="row border-bottom navbar navbar-static-top p-0 m-0 ">
      <NavRight>
        <HeaderButtonsWrapper>
          <NotesQuantityIcon
            planplan={branchPlan.plan}
            quantity={branchPlan.available_notes}
          />

          {!isNfeIssuer && (
            <div className="d-flex align-items-center">
              <CardUpgrade />
              <BuyAdditionalNotes />
              <div className="d-none d-sm-block d-md-block">
                <ButtonNews />
              </div>
            </div>
          )}
        </HeaderButtonsWrapper>

      </NavRight>
    </Nav>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/TopHeader/index.jsx